/* Flexible Content */
import accordion from '../../templates/components/accordion';
import popups from '../../templates/components/video/popups';

// Swipers
import swiperImageGallery from '../../templates/components/image-gallery';
import swiperNewsSlider from '../../templates/components/news-slider';
import swiperLinkSlider from '../../templates/components/link-slider';
import swiperTestimonialSlider from '../../templates/components/testimonial-slider';
import swiperSlider from './utils/swiper';
import newsGrid from '../../templates/components/news-grid';
import infoScroller from '../../templates/components/info-scroller';
import applicationSteps from '../../templates/components/application-steps';
import stats from '../../templates/components/stats';

// Templates
import linkScroller from '../../templates/components/link-scroller';
import instagramSlider from '../../templates/components/instagram-slider';

// import cursor from '../../templates/components/video/cursor';

// Nav
import menuButton from '../../templates/parts/top-nav/nav';
import { info } from 'autoprefixer';

// Cursors
import customCursor from '../../templates/parts/cursors';

//Animations 
import scrollAnimations from './scrollAnimations';

function consoleMessage(){
	console.log('%cCreated by %cTWK%cwww.thewebkitchen.co.uk', 'background: #13212E; color: #FFFFFF; padding: 5px 0px 5px 10px; margin: 25px 0px;', 'background: #13212E; color: #05E5C8; padding: 5px 10px 5px 0px; font-weight: bold;', 'background: #FFFFFF; padding: 5px 10px;');
}

function usingJS(){
	document.querySelector('html').classList.remove('no-js')
	document.querySelector('html').classList.add('js')
}

/* *********************** */
/* Start all the functions */
/* *********************** */
scrollAnimations();
// Custom Cursor
customCursor();

// Init
consoleMessage()
usingJS()

// change to utils...
// Swipers
swiperSlider()
// Popups
popups()
// Video
// VideoCursor()

// Strips
accordion()
swiperImageGallery()
swiperNewsSlider()
swiperLinkSlider()
swiperTestimonialSlider()
linkScroller()
newsGrid()
infoScroller()
applicationSteps()
instagramSlider()
stats();

// Nav
menuButton()

document.querySelectorAll('.prose table').forEach(table => {
	// create wrapper container
	var wrapper = document.createElement('div');
	wrapper.classList.add('table-overflow');

	// insert wrapper before el in the DOM tree
	table.parentNode.insertBefore(wrapper, table);

	// move el into wrapper
	wrapper.appendChild(table);
});

document.querySelectorAll('[data-target=accordion-content-inner] table').forEach(table => {
	// create wrapper container
	var wrapper = document.createElement('div');
	wrapper.classList.add('table-overflow');

	// insert wrapper before el in the DOM tree
	table.parentNode.insertBefore(wrapper, table);

	// move el into wrapper
	wrapper.appendChild(table);
});

var pageTitle = document.querySelector('.banner h1');
if(pageTitle) {
if(pageTitle.offsetWidth < pageTitle.scrollWidth) {
	pageTitle.classList.add('text-44');
}
}

jQuery(document).ready(function ($) {

    // prose button span insertion with text
    $('.prose-button').each(function () {

        // Get the button element
        var button = $(this);

        // Get the text from the button element
        var buttonText = button.text();

        // Remove the text from the button element
        button.text('');

        // create span elemant to hold the text
        var spanElement = document.createElement('span');

        // Insert the text from the button element into the span element
        spanElement.textContent = buttonText;

        // Append the span element to the button element
        button.append(spanElement);
    });

	anchorlinks: {
		$(document).on('click', '.scroll-to', function (event) {
			event.preventDefault();

			$('html, body').animate({
				scrollTop: $($.attr(this, 'href')).offset().top
			}, 500);
		});
	}

	externallinks: {
		$('a[href^="mailto:"]').each(function () {
			$(this).addClass('email-link');
		});	 
		
		$('a:not(.email-link):not([class^="magnific-"])').each(function () {
			var a = new RegExp('/' + window.location.host + '/');
			
			if (!a.test(this.href)) {
				$(this).click(function (event) {
				event.preventDefault();
				window.open(this.href, '_blank');
				});
			}
		});
		pdfs: {
			// Open PDFs in new window
			$(function () {
				$('a[href$=".pdf"]').prop('target', '_blank');
			});
		}
	}
});


